import { useMemo } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

export function usePageStateValue() {
	const {
		data: {
			petition,
			viewer,
			mobileAppDownloadBannerEnabled,
			mobileAppDownloadAndroidBannerEnabled,
			iOSBannerV2Enabled,
			androidBannerV2Enabled,
			desktopBannerV2Enabled,
		},
	} = useStarterDashboardV2PageData();

	return useMemo(() => {
		const {
			id,
			geoReach,
			createdAt,
			signatureState,
			user,
			tagsConnection,
			decisionMakersConnection,
			relevantLocationLocalizedName,
			score,
		} = petition;
		return {
			petition: {
				id,
				geoReach,
				relevantLocationLocalizedName,
				user,
				createdAt,
				signatureCount: signatureState.signatureCount,
				tags: tagsConnection.nodes,
				decisionMakers: decisionMakersConnection.nodes,
				score,
			},
			ownPetition: user.id === viewer.user?.id,
			mobileAppDownloadBannerEnabled,
			mobileAppDownloadAndroidBannerEnabled,
			iOSBannerV2Enabled,
			androidBannerV2Enabled,
			desktopBannerV2Enabled,
		};
	}, [
		petition,
		viewer,
		mobileAppDownloadBannerEnabled,
		mobileAppDownloadAndroidBannerEnabled,
		iOSBannerV2Enabled,
		androidBannerV2Enabled,
		desktopBannerV2Enabled,
	]);
}
